import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PTs from 'prop-types';
import React from 'react';

import { faUser } from '@fortawesome/free-regular-svg-icons';

import {
  faInfoCircle,
  faUserAstronaut,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Link from '../../../components/Link';
import PageLayout from '../../../components/PageLayout';

import TheBasicsSection from './TheBasicsSection';
import HelpForShadowersSection from './HelpForShadowersSection';
import HelpForExpertsSection from './HelpForExpertsSection';
import TrustAndSafetySection from './TrustAndSafetySection';

import s from './HelpPage.scss';

class HelpPage extends React.Component {
  static propTypes = {
    section: PTs.oneOf([
      'the-basics',
      'help-for-shadowers',
      'help-for-experts',
      'trust-and-safety',
    ]),
  };

  static defaultProps = {
    section: 'the-basics',
  };

  render() {
    const { section } = this.props;
    return (
      <PageLayout className={s.page}>
        <section className="layout">
          <div className={s.content}>
            <div>
              <nav className={s.informationNav}>
                <div className={s.navTitle}>Help Center</div>
                <Link className={s.navLink} to="/help/the-basics">
                  <FontAwesomeIcon icon={faInfoCircle} />
                  The Basics
                </Link>
                <Link className={s.navLink} to="/help/help-for-shadowers">
                  <FontAwesomeIcon icon={faUser} />
                  Help for Shadowers
                </Link>
                <Link className={s.navLink} to="/help/help-for-experts">
                  <FontAwesomeIcon icon={faUserAstronaut} />
                  Help for Experts
                </Link>
                <Link className={s.navLink} to="/help/trust-and-safety">
                  <FontAwesomeIcon icon={faShieldAlt} />
                  Trust and Safety
                </Link>
              </nav>
              <Link className={s.demographicsLink} to="/demographics">
                How Shadower can help
              </Link>
            </div>
            <div className={s.section}>
              {section === 'the-basics' && <TheBasicsSection />}
              {section === 'help-for-shadowers' && <HelpForShadowersSection />}
              {section === 'help-for-experts' && <HelpForExpertsSection />}
              {section === 'trust-and-safety' && <TrustAndSafetySection />}
            </div>
          </div>
        </section>
      </PageLayout>
    );
  }
}

export default withStyles(s)(HelpPage);
